import { render, staticRenderFns } from "./TagSelectDialog.vue?vue&type=template&id=902be3c0&scoped=true"
import script from "./TagSelectDialog.vue?vue&type=script&lang=js"
export * from "./TagSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./TagSelectDialog.vue?vue&type=style&index=0&id=902be3c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902be3c0",
  null
  
)

export default component.exports